import React from "react";
import { connect } from "react-redux";
import { Input } from "../Input/index.js";
import language from "../../language/index.js";
import { Button } from "../Button/index.js";
import api from "../../utils/api/index.js";
import toastMessage from "../../utils/toastMessage.js";
import bloodDonationQuery from "../../utils/queries/bloodDonationQuery.js";
import { fetchInventories } from "../../utils/queries/production/inventoryQuery.js";

class ReceptionRequestSingle extends React.Component {
  productInputRef = React.createRef();
  donationInputRef = React.createRef();

  state = {
    error: {},
    data: [],
    isDoneSearching: false,
    product: "",
    donationNumber: "",
    requestNo: "",
  };

  validateForm() {
    let { error, donationNumber, product } = this.state;

    if (donationNumber === "") {
      error.donationNumber =
        language[this.props.defaultLanguage].donation_number_required;
    }

    if (product === "") {
      error.product = language[this.props.defaultLanguage].product_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    try {
      if (Object.keys(this.state.error).length > 0) return;
      console.log("state data", this.state);

      const { donationNumber, product } = this.state;
      this.setState({
        isSubmitting: true,
      });

      let method = "POST",
        requestBody = {
          product,
          donationNumber,
          type: "single",
        };

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/shipping-queue/reception`,
        data: requestBody,
      };

      await api(options);

      this.setState({
        isSubmitting: false,
        donationNumber: "",
        product: "",
      });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].add_data_success,
      );
    } catch (error) {
      this.setState({ isSubmitting: false });
      toastMessage("error", error);
    }
  };

  autoFillProduct = async (donationNumber) => {
    try {
      const donations = await bloodDonationQuery(this.props.defaultLanguage, { donationNumber });
      const donationId = donations?.[0]?._id;
      if (!donationId) {
        this.productInputRef.current?.focus();
        return;
      }

      const { data } = await fetchInventories(this.props.defaultLanguage, {
        donation: donationId,
        limit: 10,
        noStockFilter: true,
      });

      if (data?.length === 1) {
        this.setState({ product: data[0].code }, () => {
          this.productInputRef.current?.focus();
        });
      } else {
        this.productInputRef.current?.focus();
      }
    } catch (_) {
      this.productInputRef.current?.focus();
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    this.setState({
      [field]: inputValue,
      isDoneSearching: false,
      ...(field === "donationNumber" ? { product: "" } : {}),
    });

    if (field === "donationNumber" && inputValue.length === 7) {
      this.autoFillProduct(inputValue);
    }

    if (field === "product" && inputValue.length === 5) {
      this.donationInputRef.current?.focus();
    }
  };

  render() {
    return (
      <>
        <Input
          placeholder={
            language[this.props.defaultLanguage].donation_number_placeholder
          }
          label={language[this.props.defaultLanguage].donation_number}
          value={this.state.donationNumber}
          onChange={(e) => this.onChangeText("donationNumber", e)}
          error={this.state.error.donationNumber}
          inputRef={this.donationInputRef}
          maxLength={7}
          inputMode="numeric"
        />

        <Input
          placeholder={language[this.props.defaultLanguage].product_placeholder}
          label={language[this.props.defaultLanguage].product}
          value={this.state.product}
          onChange={(e) => this.onChangeText("product", e)}
          error={this.state.error.product}
          inputRef={this.productInputRef}
          maxLength={5}
          inputMode="numeric"
        />

        {this.props.handleCloseModal && (
          <Button
            className="btn-default"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
        )}
        <Button
          text={language[this.props.defaultLanguage].submit}
          isSubmitting={this.state.isSubmitting}
          onPress={this.onSubmit.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ReceptionRequestSingle);
